import * as alertUserRoutines from '../AlertUser/routines';
import { connect } from 'react-redux';
import { getActiveEvent } from '../Events/selectors';
import PromptDialog from '../../Components/Dashboard/Onboarding/PromptDialog';

function mapStateToProps(state) {
    return {
        activeEvent: getActiveEvent(state),
        alertUser: state.alertUser,
    };
}
const mapDispatchToProps = {
    setInitialSettings: alertUserRoutines.setInitialSettings,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PromptDialog);
